<template v-loading="loading">
  <div class="full_layout" v-if="list!=null">
    <div class="order_num text_gray">{{$t('colon.orderNumber')}} {{list.OrderCode}}</div>
    <div class="deatil_pay_box">
      <div class="paidPay">
        <div class="text_gray" v-if="list.OrderStatus==4">{{OrderStatus[5]}}</div>
        <div v-else :class="list.OrderStatus==1 ? 'text_red':'text_orange'">{{OrderStatus[list.OrderStatus]}}</div>
        <span v-if="list.OrderStatus==1" class="" @click="BuyItNow(list)">{{$t('base.payNow')}}</span>
      </div>
      <div class="steps_box">
        <div class="greed">
          <div class="dot first">
            <span class="yes shipped"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
          </div>
          <div class="steps_txt first">
            {{$t('base.submitOrders')}}<br>{{list.CreateDate|setTimeSS}}
          </div>
        </div>
        <div :class="list.OrderStatus>=2 && list.OrderStatus<6?'greed':''">
          <div class="dot">
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="yes transit"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
          </div>
          <div class="steps_txt" v-if="list.OrderStatus>=2">
            {{$t('base.payForOrder')}}<br>{{list.PayDateTime|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{$t('base.payForOrder')}}
          </div>
        </div>
        <div :class="list.OrderStatus>=3  && list.OrderStatus<6?'greed':''">
          <div class="dot">
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="yes delivery"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="dot_s"></span>
          </div>
          <div class="steps_txt" v-if="list.OrderStatus>=3">
            {{$t('base.sellerShipped')}}<br>{{list.SendDateTime|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{$t('base.shipped')}}
          </div>
        </div>
        <div :class="list.OrderStatus>=4  && list.OrderStatus<6?'greed':''">
          <div class="dot">
            <span class="dot_s"></span>
            <span class="dot_s"></span>
            <span class="yes delivered"></span>
          </div>
          <div class="steps_txt" v-if="list.OrderStatus>=4">
            {{$t('base.finish')}}<br>{{list.CompleteTime|setTimeSS}}
          </div>
          <div class="steps_txt" v-else>
            {{$t('base.finish')}}
          </div>
        </div>
      </div>
    </div>
    <div class="detail_box">
      <div class="detail_info">
        <div class="detail_info_box">
           <h3>{{$t('base.buyerInfo')}}</h3>
           <div>
            <span>{{$t('base.nickName')}}</span>
            <div class="detail_msg">
              {{userInfo.NickName == !userInfo.NickName?'-':userInfo.NickName}}
            </div>
          </div>
          <div>
            <span>{{$t('base.shippingName')}}</span>
            <div class="detail_msg">
              {{orderAdd.UserName+' '+orderAdd.Phone}}
            </div>
          </div>
          <div>
            <span>{{$t('base.shippingAddress')}}</span>
            <div class="address_s">
              <div v-if="orderAdd.StreetAddress"> {{orderAdd.StreetAddress}},{{orderAdd.StreetAddress2}}</div>
             <div v-if="orderAdd.City">{{orderAdd.City}},</div>
              <div v-if="orderAdd.State">{{orderAdd.State}},</div>
              <div v-if="orderAdd.ZipCode">{{orderAdd.ZipCode}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail_steps" v-if="list.OrderStatus!=1">
        <el-scrollbar v-if="expList&&expList.TrackList&&expList.TrackList.length>0">
        <div class="steps_list" v-for="(item,index) in expList.TrackList" :key="index">
          <div class="steps_list_up">
            <span class="time">{{item.TrackDate|setTimeSS}}</span>
            <span class="dott"></span>
            <span class="add">{{item.TrackStatus}}</span>
          </div>
          <div class="steps_line"></div>
        </div>
      </el-scrollbar>
        <div class="steps_list error" v-else>
          <div>{{$t('base.NoLogistics')}}</div>
        </div>
      </div>

        <div class="detail_steps" v-else></div>
    </div>
    <div class="table_detail_box" >
      <div class="table_head BusinessType">
        <div class="commod head_box">{{$t('base.commodity')}}</div>
        <div class="head_box">{{$t('base.quantity')}}</div>
        <div class="head_box">{{$t('base.itemPrice')}}</div>
        <div class="head_box">{{$t('base.operate')}}</div>
      </div>
      <div class="table_detail">
        <div class="table_list_detail BusinessType oneOnly">
          <div v-for="(res,i) in list.CommodityList" :key="i">
            <div class="like_box">
              <el-image class="like_img" :src="res.GFCommodityBody.Imgs[0]" fit="contain"></el-image>
              <div class="like_detail">
                <p>{{res.GFCommodityBody.Title}}</p>
              </div>
            </div>
            <div class="head_box">
              <div>{{res.Quantity}}</div>
              <!-- <div class="text_blue">3 bids</div> -->
            </div>
            <div class="head_box">
              <div>{{list.Currency}} {{formatAmount(res.Price)}}</div>
              <!-- <div class="text_blue">3 bids</div> -->
            </div>
          </div>
        </div>
        <div class="head_box setTotalPrice">
          <div class="hover" @click="allContact()">{{$t('base.contactSeller')}}</div>
        </div>
      </div>
    </div>
    <div class="BusinessTypeTaxPrice" >
      <ul>
        <li><span>{{$t('colon.subtotal')}}</span><span>{{list.Currency}} {{formatAmount(list.PriceTotal)}}</span></li>
        <li><span>{{$t('colon.shipping')}}</span><span>{{list.Currency}} {{formatAmount(list.Postage)}}</span></li>
        <li><span>{{$t('base.stateTax')}}</span><span>{{list.Currency}} {{formatAmount(list.TaxAmount)||0}}</span></li>
        <li class="total"><span>{{$t('colon.orderTotal')}}</span><span>{{list.Currency}} {{formatAmount(list.OrderAmount)}}</span></li>
      </ul>
    </div>
  </div>
</template>
<script>
import bus from '@/api/bus';
import { getInfo, getTime, countDown, setUTC, numAdd,formatAmount, numMulti, isNumber, doveCountDown, numDiv, priceExchange } from "@/api/public";
export default {
  name: 'tabslist',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      userInfo: null,
      loading: false,
      list: null,
      orderId: '',
      postageMoney:'',
      postPrice:'',
      orderAdd:'',
      OrderStatus: this.$enumInfo.OrderStatus,
      expList:null

    }
  },
  filters: {
    setTimeSS(val) {
      if (!val) {
        return null
      }
      return getTime(val, -8, 0, 'cn')
    },
  },
  created() {
    // this.list = window.sessionStorage.getItem('history');
    // this.list = JSON.parse(this.list);orderId
    this.userInfo = getInfo()
    this.orderId = this.$route.params.id
    this.OrdersDetail()
    bus.$emit('headerTitle', this.$t('base.myCardHobby'));

  },
  mounted() {},
  methods: {
    formatAmount(obj){
      return formatAmount(obj)
    },
    // 云信
    allContact(val) {
      this.$root.$emit("contactUS", true);
    },
    //type 1：官方商城折扣前总价
    setTotalPrice(obj) {
      return numAdd(isNumber(obj.OrderAmount),isNumber(obj.TaxAmount))
    },
    // 一口价跳转checkout
    BuyItNow(val) {

      this.$router.push({
        path: '/pay/storecheckout/' + val.Id
      })
    },
    // 获取订单详情
    OrdersDetail() {
      let that = this;
      that.loading = true;
      let data = { memberid: that.userInfo.MappingUserId, orderId: that.orderId }
      this.$get(this.$interface.GetStoreOrderById, data).then(res => {
        if (res.Result != 0) {
          that.list = res.Data;

          let data = res.Data
          let add = data.AddressMsg.AddressDetail
          let detail = {}
          that.areaSymbol = data.Currency
          if (add) {
            if (add.indexOf('()') > 0) {
              // var a=add1.indexOf('()')
              // console.log(add1,a,'add2',add1.substring(0,a))
              //var reg=new RegExp()
              add = add.replace(/\(\)/g, "")
              add = [add]
              //console.log(add, 'add1')
            } else {
              if (add.indexOf(')') != -1) {
                add = add.replace(")", "")
                add = add.replace("(", "|")
              }
              add = add.split("|")
              //console.log(add, add[0], 'add2')
            }
          }
          // 重组地址信息
          let result = {
            UserName: data.AddressMsg.Consignee,
            Country: data.AreaCode,
            StreetAddress: add[0] ? add[0] : add,
            StreetAddress2: add[1] ? add[1] : '',
            ZipCode: data.AddressMsg.PostalCode,
            City: data.AddressMsg.CityName,
            State: data.AddressMsg.ProvinceName,
            Phone: data.AddressMsg.Telephone,
            StateCode: '',
          }
          
          that.postPrice = data.Postage

          if (data.PostageType == '1') {
            that.postageMoney = that.$t('base.payOnDelivery')
          } else if (data.PostageType == '2') {
            that.postageMoney = that.$t('base.freeShipping')
          } else {
            that.postageMoney = ''
          }

          this.orderAdd = result;
          if (data.OrderStatus != 1) {
            this.GetExpress(data)
          }
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }

        that.loading = false;
      })
    },
    // 获取物流信息
    GetExpress(obj) {
      let that = this;
      that.exploading = true
      that.expList = '';
      let data = { OrderId:obj.Id,shipperCode:obj.LogisticsCompanyCode,logisticCode:obj.LogisticsCode}
      //let data = {"OrderId":"5061677704650192080","shipperCode":"YTO","logisticCode":"YT1819952506580" }
      this.$post(this.$interface.GetExpressSubscribeInfo, data).then(res => {
        if (res.Result != 0) {
          var data=res.Data
          //console.log(res.Data[0],'res.Data')
            that.expList = data[0].Tracklist
          
        } else {
          //that.expList = { Traces: [] }
        }
        that.exploading = false
        //console.log(res)
      })
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/orderdetail.css";

.table_head .commod {
  width: 495px;
  padding-left: 108px;
}

.table_head.BusinessType .commod {
  width: 718px;
}

.table_head .Premium {
  width: 200px;
}

.table_list_detail .like_box {
  width: 388px;
}

.table_list_detail .like_detail {
  width: 288px;
}

.table_list_detail.noOne {
  width: 645px;
}

.table_list_detail.noOne.BusinessType {
  width: calc(100% - 118px);
}

.order_type .head_box.RealPostageMoney {
  width: 130px;
}

.head_box.ServiceFee {
  width: 158px;
}

.head_box.TaxPrice {
  width: 128px;
}

.order_type .head_box.setTotalPrice {
  width: 118px;
  padding-right: 0;
}

.ordertype .table_list_detail>div:first-child {
  min-width: 645px;
  width: auto;
}

.ordertype .head_box.RealPostageMoney {
  width: 158px;
}

.ordertype .head_box.setTotalPrice {
  width: 150px;
}

.table_list_detail .like_box {
  width: 488px;
}

.table_list_detail.BusinessType .like_box {
  width: 710px;
}

.table_list_detail.BusinessType .like_detail {
  width: calc(100% - 100px);
}

.RemainingAlert {
  margin-top: 12px;
}

.hover {
  cursor: pointer;
}

.hover:hover {
  color: #5F6DAE;
  text-decoration: underline;
}

.BusinessTypeTaxPrice {
  display: flex;
  justify-content: flex-end;
}

.BusinessTypeTaxPrice+.BusinessTypeTaxPrice {
  justify-content: space-between;
  border-top: 1px solid #d9d9d9;
  margin-top: 10px;
  padding-top: 10px;
}

.BusinessTypeTaxPrice .icon_text {
  display: flex;
  width: 50%;
  color: #a0a0a0;
}

.BusinessTypeTaxPrice .icon_text p {
  margin-left: 3px;
}

.BusinessTypeTaxPrice ul {
  width: 275px;
}

.BusinessTypeTaxPrice ul li {
  display: flex;
  line-height: 2;
}

.BusinessTypeTaxPrice ul li span {
  width: 200px;
  text-align: left;
  color: #a0a0a0;
}

.BusinessTypeTaxPrice ul li span+span {
  text-align: right;
  color: #333;
}

.BusinessTypeTaxPrice ul li.total span {
  color: #5F6DAE;
}

.BusinessTypeTaxPrice ul li.total span+span {
  font-size: 18px;
  font-weight: 700;
}
.paidPay span{
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/malldetail.vue